import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Col, Row, Table, Button, Modal, Form } from "antd";
import { columnsData } from "./columns";
import "./style.css";
import { BUTTONS, FORMS, ROUTES } from "../common/constants";
import CreateVehicleForm from "./form";
import { getApis } from "../common/api";
import { vehicleDetailsListApiUrl } from "../common/endpoints";
import ChangeOrganisation from "../common/ChangeOrganisation";
import { useNavigate } from "react-router";

const Vehicles = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const orgDetails = useSelector((state) => state.org);
  const [modalOpen, setModalOpen] = useState(false);
  const [vehiclesTableData, setVehiclesTableData] = useState({
    list: [],
    totalElements: 0,
    loading: true,
  });
  const [paginationDetails, setPaginationDetails] = useState({
    current: 1,
    pageSize: 10,
    refresh: false,
  });

  const getVehicleDetailsList = useCallback(async () => {
    await getApis(
      vehicleDetailsListApiUrl,
      {
        page: paginationDetails.current - 1,
        size: paginationDetails.pageSize,
        // orgId: orgDetails?.id,
      },
      orgDetails?.token || authToken
    )
      .then((response) => {
        setVehiclesTableData((prev) => ({
          ...prev,
          list: response?.data?.vehicleDetailDto || [],
          totalElements: response?.data?.totalElements,
          loading: false,
        }));
      })
      .catch((error) => {
        console.log(error);
        setVehiclesTableData((prev) => ({
          ...prev,
          list: [],
          totalElements: 0,
          loading: false,
        }));
      });
    // eslint-disable-next-line
  }, [paginationDetails.refresh]);

  useEffect(() => {
    getVehicleDetailsList();
  }, [getVehicleDetailsList]);

  useMemo(() => {
    if(orgDetails?.token){
      setPaginationDetails((prev) => ({
        ...prev,
        current: 1,
        refresh: !prev.refresh
      }));
    }
  }, [orgDetails?.token])

  const handleCancel = () => {
    setModalOpen(false);
  };

  const handleSubmit = async (values) => {
    setModalOpen(false);
  };

  const handlePageChange = (pagination) => {
    setPaginationDetails((prev) => ({
      current: pagination.current,
      pageSize: pagination.pageSize,
      refresh: !prev.refresh
    }));
  };

  const viewModelDetail = (data) => {
    navigate(ROUTES.VEHICLE_MODEL, {
      state: { orgId: orgDetails?.id, vehModelId: data?.vehicleModelId },
    });
  }

  const viewPartsDetail = (data) => {
    navigate(ROUTES.VEHICLE_PARTS, {
      state: { orgId: orgDetails?.id, vehId: data?.vehId },
    });
  }

  const columns = columnsData(viewPartsDetail, viewModelDetail);

  return (
    <>
      <Row justify="space-between" className="flex-center">
        <Col span={4} className="head">
          Vehicles
        </Col>
        <Col xs={10} sm={6} md={6} lg={3}>
          <Button type="primary" disabled onClick={() => setModalOpen(true)}>
            {BUTTONS.ADD_NEW}
          </Button>
        </Col>
      </Row>
      <ChangeOrganisation />
      <Row justify="center" className="mt1">
        <Col span={24}>
          <Table
            columns={columns}
            rowKey={(record) => record?.vehId}
            dataSource={vehiclesTableData?.list}
            scroll={{ x: "100%" }}
            onChange={handlePageChange}
            className="vehicles-list-table"
            pagination={{
              current: paginationDetails.current,
              pageSize: paginationDetails.pageSize,
              total: vehiclesTableData.totalElements,
              showSizeChanger: false,
              showQuickJumper: false,
              hideOnSinglePage: true,
            }}
          />
        </Col>
      </Row>
      <Modal
        title={FORMS.VEHICLE.HEADER}
        centered
        open={modalOpen}
        onOk={form.submit}
        onCancel={handleCancel}
        footer={null}
        className="vehicle-add-modal"
      >
        <CreateVehicleForm handleSubmit={handleSubmit} />
      </Modal>
    </>
  );
};

export default Vehicles;
